/* eslint-disable @next/next/no-img-element */
import React from "react";
import { Button } from "ui-v2/components/Button";
import { Modal } from "ui-v2/components/Modal/Modal";
import { Typography } from "ui-v2/components/Typography";

import s from "./ConfirmDelete.module.scss";
import Icon from "ui-v2/components/Icon/Icon";

type ConfirmDeleteProps = {
  isShow: boolean;
  onClose: () => void;
  onDone: () => void;
  isLoading: boolean;
  zIndex?: number;
};

export const ConfirmDelete = ({
  isShow,
  onClose,
  onDone,
  isLoading,
  zIndex = 105,
}: ConfirmDeleteProps) => (
  <Modal
    show={isShow}
    head={{ show: true, title: "", onClose: onClose }}
    closeOnClickOutside={false}
    noPadding
    animation={{ type: "btt", timeout: "s" }}
    rootStyle={{
      zIndex,
    }}
  >
    <div className={s.root}>
      <div className={s.upper}>
        <div className={s.image_container}>
          <Icon name="TrashRegular" width={48} height={48} />
        </div>
        <div className={s.text_container}>
          <div className={s.title}>
            <Typography variant="h_2_bold" label="Delete this address" />
          </div>
          <div className={s.sub_title}>
            <Typography
              variant="label_2_medium"
              color="secondary"
              label="Are you sure you want to delete this address?"
            />
          </div>
        </div>
      </div>

      <div className={s.button_container}>
        <Button
          label="Delete"
          onClick={onDone}
          loading={isLoading}
          disabled={isLoading}
          variant="negative"
          size="medium"
          fullWidth
        />
        <Button
          label="Cancel"
          variant="ghost_color"
          size="medium"
          fullWidth
          onClick={onClose}
          disabled={isLoading}
        />
      </div>
    </div>
  </Modal>
);
